"use strict";
/** Γραμμές σημειώσεων site — αποθήκευση σε `raw_notes` με `\n`. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinSiteNoteLines = joinSiteNoteLines;
exports.parseSiteNoteLines = parseSiteNoteLines;
function joinSiteNoteLines(lines) {
    return lines
        .map((line) => line.trim())
        .filter(Boolean)
        .join('\n');
}
function parseSiteNoteLines(rawNotes) {
    if (!(rawNotes === null || rawNotes === void 0 ? void 0 : rawNotes.trim()))
        return [];
    return rawNotes
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
}
